document.addEventListener('alpine:init', () => {
    Alpine.data('instagramPostsGrid', () => ({
        posts: [],
        instagramModalOpen: false,
        activePost: {},
        touchStartX: 0,
        touchStartY: 0,

        init() {
            this.syncPostsFromDom();
            // htmx swaps "Load More" batches into $refs.grid without a page
            // reload, so re-scan for the modal's posts array to stay in sync.
            this.$refs.grid.addEventListener('htmx:afterSwap', () => this.syncPostsFromDom());
        },

        syncPostsFromDom() {
            this.posts = Array.from(this.$refs.grid.querySelectorAll('[data-post]'))
                .map(button => JSON.parse(button.dataset.post));
        },

        openPost(id) {
            this.setActivePost(id);
            this.instagramModalOpen = true;
        },

        setActivePost(id) {
            this.activePost = this.posts.find(post => post.id === id) ?? {};
        },

        nextPost() {
            if (!this.instagramModalOpen) return;
            this.stepPost(1);
        },

        prevPost() {
            if (!this.instagramModalOpen) return;
            this.stepPost(-1);
        },

        stepPost(delta) {
            const index = this.posts.findIndex(post => post.id === this.activePost.id);
            if (index === -1 || this.posts.length === 0) return;

            const nextIndex = (index + delta + this.posts.length) % this.posts.length;
            this.setActivePost(this.posts[nextIndex].id);
        },

        // Only fires on touch input to begin with, so this is effectively
        // mobile-only without needing device/viewport sniffing.
        handleTouchStart(event) {
            const touch = event.changedTouches[0];
            this.touchStartX = touch.clientX;
            this.touchStartY = touch.clientY;
        },

        handleTouchEnd(event) {
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - this.touchStartX;
            const deltaY = touch.clientY - this.touchStartY;
            const swipeThreshold = 50;

            // Ignore short or mostly-vertical gestures so scrolling isn't hijacked.
            if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

            if (deltaX < 0) {
                this.nextPost();
            } else {
                this.prevPost();
            }
        },
    }));
});
